import React, { useState } from 'react';
import PropTypes from 'prop-types';

const NestedRow = ({ row, renderRow, nestingConfig }) => {
  const [isExtended, setIsExtended] = useState(false);

  const { childrenKey } = nestingConfig;

  const children = row[childrenKey] || [];

  const handleExtendToggle = () => {
    setIsExtended(!isExtended);
  };

  const renderChildrenRows = () => {
    if (!Array.isArray(children) || !isExtended) {
      return null;
    }
    return children.map((childRow) =>
      renderRow({ row: childRow, isChild: true })
    );
  };

  return (
    <>
      {renderRow({
        row,
        nestingExtendAction: handleExtendToggle,
        isExtended,
        hasChildren: !!children.length,
      })}
      {renderChildrenRows()}
    </>
  );
};

NestedRow.propTypes = {};

export default NestedRow;
